import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Phone, CheckCircle } from 'lucide-react';

const HeroSection = () => {
  const benefits = [
    'Transparent Estimates',
    'Local Experienced Team',
    'Personalized Styling Approach',
  ];

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=2400&q=80')`,
        }}
      >
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="container-main relative z-10 pt-32 pb-20">
        <div className="max-w-2xl">
          <h1
            data-testid="hero-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-6 animation-fade-up"
          >
            Thoughtful Home Decoration Services in{' '}
            <span className="text-[#C5A065]">New York</span>
          </h1>
          <p
            data-testid="hero-subheadline"
            className="text-lg md:text-xl text-white/90 mb-8 animation-fade-up delay-100 font-light leading-relaxed"
          >
            Personalized decorative enhancements designed to complement your
            lifestyle and space.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 animation-fade-up delay-200">
            <Link to="/contact">
              <Button
                data-testid="hero-cta-primary"
                className="btn-accent text-base px-10 py-5"
              >
                Schedule Free Consultation
              </Button>
            </Link>
            <a href="tel:+18888801455">
              <Button
                data-testid="hero-cta-secondary"
                variant="outline"
                className="bg-transparent border-white text-white hover:bg-white hover:text-[#2D2D2D] px-10 py-5"
              >
                <Phone className="mr-2 h-4 w-4" />
                Call Now
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-6 animation-fade-up delay-300">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                data-testid={`hero-benefit-${index}`}
                className="flex items-center gap-2 text-white/90"
              >
                <CheckCircle className="h-5 w-5 text-[#C5A065]" />
                <span className="text-sm font-light">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animation-fade-up delay-500">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/70 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
